import { CallAdapterState, VideoBackgroundEffect } from "@azure/communication-react";

export const getSelectedVideoEffect = (state: CallAdapterState): VideoBackgroundEffect | undefined =>
    state.selectedVideoBackgroundEffect;
